module.exports = __webpack_public_path__ + "static/img/bus-content-1.c61bb3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bus-content-1.jpg
// module id = +gbZ
// module chunks = 0